import { ChevronDown, ChevronUp } from "lucide-react";
import * as React from "react";
import { useState } from "react";

interface CardBoxProps {
  title?: string;
  titleColor?: string;
  titleAction?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  collapsable?: boolean;
  defaultCollapsed?: boolean;
  collapsedTitle?: React.ReactNode;
}

export const CardBox: React.FC<CardBoxProps> = ({
  title,
  titleColor = "text-green-400",
  titleAction,
  children,
  className = "",
  collapsable = false,
  defaultCollapsed = false,
  collapsedTitle,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);
  
  const toggleCollapsed = () => {
    if (collapsable) {
      setIsCollapsed(!isCollapsed);
    }
  };

  return (
    <div
      className={`bg-secondary pt-3 px-3 rounded-md border border-border ${className} ${isCollapsed ? "" : "pb-3"}`}
    >
      <div
        className={`${collapsable ? "cursor-pointer hover:bg-card relative" : ""} ${isCollapsed ? "" : "mb-2"} -mx-3 -mt-3 p-3 rounded-t transition-colors`}
        onClick={toggleCollapsed}
      >
        {title && (
          <div className="flex items-center justify-between">
            <div
              className={`${titleColor} font-semibold text-sm flex-1 flex items-center gap-2 min-w-0 pr-6`}
            >
              <span className="min-w-0 break-words">{title}</span>
              {isCollapsed && collapsable && collapsedTitle && (
                <span className="text-muted-foreground font-normal min-w-0 flex-1 truncate border-l border-border opacity-75 pl-2 ">
                  {collapsedTitle}
                </span>
              )}
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              {titleAction && <div onClick={(e) => e.stopPropagation()}>{titleAction}</div>}
              {collapsable && (
                <span className="text-muted-foreground">
                  {isCollapsed ? (
                    <ChevronDown className="h-4 w-4" />
                  ) : (
                    <ChevronUp className="h-4 w-4" />
                  )}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
      {(!isCollapsed || !collapsable) && children}
    </div>
  );
};